import React from "react"
import { useSelector } from "react-redux"
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core"
import ConnectedPreferenceCenter from "@root/pages/components/ConnectedPreferenceCenter"
import {
  selectPreferenceCenterMetadata,
  selectPreferenceCenters,
} from "@root/store/selectors"

const ContactPreferenceCenters: React.FC = () => {
  const preferences = useSelector(selectPreferenceCenters)
  const metadata = useSelector(selectPreferenceCenterMetadata)

  const [id, setId] = React.useState("")

  const definition = preferences.find((pref) => pref.id === id)

  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="contact-preference-center-label">
          Preference Center
        </InputLabel>
        <Select
          data-qa-selector="preference-center-select"
          labelId="contact-preference-center-label"
          id="preference-center-id"
          value={id}
          onChange={(ev) => setId(ev.target.value as string)}
        >
          {metadata
            // filter out bad pref center definitions in the laziest way possible
            .filter((pref) => Boolean(pref.id))
            .filter((pref) => pref.type === "contact")
            .map((pref, idx) => (
              <MenuItem key={`${pref.id}.${idx}`} value={pref.id}>
                {pref.name || pref.id}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      {definition && <ConnectedPreferenceCenter definition={definition} />}
    </>
  )
}

export default ContactPreferenceCenters
